import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, theme }) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { borderRadius: '16px' } }}
    >
        <DialogTitle
            sx={{
                backgroundColor: theme.palette.error.main,
                color: '#fff',
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <Delete sx={{ color: '#fff' }} />
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Delete Lesson
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'rgba(255,255,255,0.7)',
                        display: 'block',
                    }}
                >
                    This action cannot be undone.
                </Typography>
            </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4, mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
                Are you sure you want to delete this lesson? All associated
                resources, assessments, and labs will also be removed.
            </Typography>
        </DialogContent>
        <DialogActions
            sx={{
                p: 3,
                backgroundColor: theme.palette.grey[50],
                borderTop: `1px solid ${theme.palette.divider}`,
            }}
        >
            <Button
                onClick={onClose}
                color="inherit"
                sx={{
                    fontWeight: 600,
                    textTransform: 'none',
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={onConfirm}
                variant="contained"
                color="error"
                sx={{
                    fontWeight: 'bold',
                    px: 3,
                    borderRadius: '8px',
                    textTransform: 'none',
                }}
            >
                Delete Lesson
            </Button>
        </DialogActions>
    </Dialog>
);

export default DeleteConfirmDialog;
